// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const duosion: PokeData = {
  "id": 578,
  "name": "duosion",
  "height": 6,
  "weight": 80,
  "base_experience": 130,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "psybeam",
    "confusion",
    "psychic",
    "recover",
    "light-screen",
    "reflect",
    "psywave",
    "protect",
    "charm",
    "rollout",
    "pain-split",
    "hidden-power",
    "future-sight",
    "endeavor",
    "skill-swap",
    "snatch",
    "heal-block",
    "wonder-room",
    "psyshock",
    "ally-switch"
  ],
  "moves": [
    "psychic",
    "reflect",
    "psywave",
    "protect",
    "future-sight",
    "snatch",
    "synchronize",
    "psy-ball",
    "kinesis",
    "psychic-terrain",
    "zen-headbutt",
    "prismatic-cage",
    "psychic-fangs"
  ],
  "evolution_chain": {
    "id": 294,
    "item": null,
    "species": [
      {
        "name": "solosis",
        "order": 578,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "duosion",
        "order": 579,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 577,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "reuniclus",
        "order": 580,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 578,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 41,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 60,
    "speed": 30,
    "ability_power": 125
  },
  "stat_changes": [],
  "catch_rate": 100,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
